import React, {useEffect, useMemo} from "react";
import {Modal, Table, Card, Button} from "react-bootstrap";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {ModalProgressBar} from "../../../../_metronic/_partials/controls";
import * as formatter from "../../../../utils/formatter";
import * as actions from "../../../../redux/modules/qna/actions";
import {ORDER_STATUS, REPLY_STATUS} from "../../../../utils/codes";
import {OrderProductsTable} from "../OrderProductsTable";

export function QNADetailModal({show, onHide, qnaId}) {
  // Products Redux state
  const dispatch = useDispatch();
  const {isLoading, qna} = useSelector(
    (state) => ({
      isLoading: state.qna.actionsLoading,
      qna: state.qna.qna,
    }),
    shallowEqual
  );

  const format = useMemo(() => ({
    ChipFormatter: formatter.chip(REPLY_STATUS),
    DotFormatter: formatter.dot(ORDER_STATUS),
    DateFormatter: formatter.dateTime,
  }), []);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  useEffect(() => {
    if (qnaId) dispatch(actions.fetchQNA(qnaId));
  }, [qnaId, dispatch]);

  if (!qna) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="example-modal-sizes-title-lg"
      centered
    >
      {isLoading && <ModalProgressBar/>}
      <Modal.Header>
        <div>
          <h3>문의 상세</h3>
          <span className="text-dark-50">구매자의 문의 상세 내용을 확인하세요.</span>
        </div>
      </Modal.Header>
      <Modal.Body>

        <Table bordered responsive={true}>
          <colgroup>
            <col width="20%"/>
            <col width="30%"/>
            <col width="20%"/>
            <col width="30%"/>
          </colgroup>
          <tbody>
          <tr>
            <th>답변 상태</th>
            <td>{format.ChipFormatter(qna.ansSttsCd)}</td>
            <th>주문 상태</th>
            <td>{format.DotFormatter(qna.ordSttsCd)}</td>
          </tr>
          <tr>
            <th>질문 일시</th>
            <td>{format.DateFormatter(qna.queDtime)}</td>
            <th>주문 일시</th>
            <td>{format.DateFormatter(qna.ordDtime)}</td>
          </tr>
          <tr>
            <th>주문 번호</th>
            <td>{qna.ordNo}</td>
            <th>주문자</th>
            <td>{qna.ordUserNm}</td>
          </tr>
          </tbody>
        </Table>

        <p className="font-weight-boldest text-primary mt-2 mb-2">주문 상품 정보</p>
        <OrderProductsTable products={qna.ordGoodsList} />

        <Card bg={'light'} className="mb-4">
          <Card.Body className="p-5">
            <p className="font-weight-boldest text-primary mt-2 mb-2 pl-3">문의 내용</p>
            <Table responsive={true} className="m-0">
              <colgroup>
                <col width="120px"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
              <tr>
                <th className="border-0">문의 일시</th>
                <td className="border-0">{format.DateFormatter(qna.queDtime)}</td>
              </tr>
              <tr>
                <th className="border-0">문의 제목</th>
                <td className="border-0">{qna.title}</td>
              </tr>
              <tr>
                <th className="border-0">문의 내용</th>
                <td className="border-0">{qna.queConts}</td>
              </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>

        {qna.ansSttsCd !== '01' && (
          <Card bg={'light'}>
            <Card.Body className="p-5">
              <p className="font-weight-boldest text-primary mt-2 mb-2 pl-3">답변 내용</p>
              <Table responsive={true} className="m-0">
                <colgroup>
                  <col width="120px"/>
                  <col width="auto"/>
                </colgroup>
                <tbody>
                <tr>
                  <th className="border-0">답변 일시</th>
                  <td className="border-0">{format.DateFormatter(qna.ansDtime)}</td>
                </tr>
                <tr>
                  <th className="border-0">답변 내용</th>
                  <td className="border-0">{qna.ansConts}</td>
                </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            className="btn btn-elevate w-130px btn-dark"
            onClick={onHide}
          >
            확인
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
